import AnalysisStudyLogPerformanceConstants from "./AnalysisStudyLogPerformanceConstants.js";
function loadStart(clientTimeInMs) {
  return {
    type: AnalysisStudyLogPerformanceConstants.LOAD_START,
    payload: { clientTimeInMs }
  };
}
function loadStartV2StudyList(clientTimeInMs) {
  return {
    type: AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_LIST,
    payload: { clientTimeInMs }
  };
}
function loadStartV2Study(clientTimeInMs) {
  return {
    type: AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY,
    payload: { clientTimeInMs }
  };
}
function loadStartV2StudyTask(clientTimeInMs) {
  return {
    type: AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_TASK,
    payload: { clientTimeInMs }
  };
}
function stepMetadataMainFunctionality(perfEntry) {
  return {
    type: AnalysisStudyLogPerformanceConstants.STEP_METADATA_MAIN_FUNCTIONALITY,
    payload: perfEntry
  };
}
function forayMetadataMainFunctionality(perfEntry) {
  return {
    type: AnalysisStudyLogPerformanceConstants.FORAY_METADATA_MAIN_FUNCTIONALITY,
    payload: perfEntry
  };
}
function studyAbstractsV2MainFunctionality(perfEntry) {
  return {
    type: AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACTS_V2_MAIN_FUNCTIONALITY,
    payload: perfEntry
  };
}
function studyAbstractV2MainFunctionality(perfEntry) {
  return {
    type: AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACT_V2_MAIN_FUNCTIONALITY,
    payload: perfEntry
  };
}
function studyTaskV2MainFunctionality(perfEntry) {
  return {
    type: AnalysisStudyLogPerformanceConstants.STUDY_TASK_V2_MAIN_FUNCTIONALITY,
    payload: perfEntry
  };
}
function mainFunctionality(timeSinceLoadStartInMs, lastPartToLoad) {
  return {
    type: AnalysisStudyLogPerformanceConstants.MAIN_FUNCTIONALITY,
    payload: { timeSinceLoadStartInMs, lastPartToLoad }
  };
}
export {
  forayMetadataMainFunctionality,
  loadStart,
  loadStartV2Study,
  loadStartV2StudyList,
  loadStartV2StudyTask,
  mainFunctionality,
  stepMetadataMainFunctionality,
  studyAbstractV2MainFunctionality,
  studyAbstractsV2MainFunctionality,
  studyTaskV2MainFunctionality
};
//# sourceMappingURL=AnalysisStudyLogPerformanceActions.js.map
